
import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { collection, addDoc, deleteDoc, doc, onSnapshot, query, orderBy, updateDoc } from 'firebase/firestore';

const toYMD=(d)=>{const dt=new Date(d);const y=dt.getFullYear(),m=String(dt.getMonth()+1).padStart(2,'0'),day=String(dt.getDate()).padStart(2,'0');return `${y}-${m}-${day}`;};

function WeekCard({week}){
  const [rows,setRows]=useState(week.rows||[]);
  useEffect(()=>setRows(week.rows||[]),[week.id]);
  const addRow=()=>setRows([...rows,{summary:'',lane:'',puDate:'',delDate:'',weight:''}]);
  const save=async()=>{await updateDoc(doc(db,'weeklyAgenda',week.id),{rows});};
  const remove=async()=>{ if(!window.confirm('Delete this week?'))return; await deleteDoc(doc(db,'weeklyAgenda',week.id)); };
  const setVal=(i,k,v)=>{const next=[...rows]; next[i]={...next[i],[k]:v}; setRows(next);};
  return(<div className='card agenda-week'>
    <div className='agenda-header'>
      <div className='agenda-title'>Week of {week.weekOf}</div>
      <div>
        <button className='btn small primary' onClick={save}>Save</button>
        <button className='btn small' onClick={remove}>Delete Week</button>
      </div>
    </div>
    <div className='agenda-head agenda-row'>
      <div>Summary</div><div>Lane</div><div>PU Date</div><div>DEL Date</div><div>Weight</div><div></div>
    </div>
    {rows.map((r,i)=>(
      <div key={i} className='agenda-row'>
        <input className='agenda-input' value={r.summary} onChange={e=>setVal(i,'summary',e.target.value)} />
        <input className='agenda-input' value={r.lane} onChange={e=>setVal(i,'lane',e.target.value)} />
        <input className='agenda-input' type='date' value={r.puDate||''} onChange={e=>setVal(i,'puDate',e.target.value)} />
        <input className='agenda-input' type='date' value={r.delDate||''} onChange={e=>setVal(i,'delDate',e.target.value)} />
        <input className='agenda-input' value={r.weight||''} onChange={e=>setVal(i,'weight',e.target.value)} />
        <button className='btn tiny' onClick={()=>setRows(rows.filter((_,x)=>x!==i))}>🗑️</button>
      </div>
    ))}
    <button className='btn small' onClick={addRow}>Add Row</button>
  </div>);
}

export default function WeeklyAgenda(){
  const [weeks,setWeeks]=useState([]);
  const [weekOf,setWeekOf]=useState(toYMD(new Date()));
  useEffect(()=>{
    const qy=query(collection(db,'weeklyAgenda'),orderBy('weekOf','desc'));
    return onSnapshot(qy,snap=>setWeeks(snap.docs.map(d=>({id:d.id,...d.data()}))));
  },[]);
  const addWeek=async()=>{
    await addDoc(collection(db,'weeklyAgenda'),{weekOf,rows:[],createdAt:new Date().toISOString()});
  };
  return(<div>
    <div className='card'>
      <h3>Weekly Sales Agenda</h3>
      <div style={{display:'flex',gap:8,alignItems:'center'}}>
        <label>Week of</label>
        <input type='date' value={weekOf} onChange={e=>setWeekOf(e.target.value)} />
        <button className='btn primary' onClick={addWeek}>Add Week</button>
      </div>
    </div>
    <div style={{marginTop:12,display:'grid',gap:12}}>
      {weeks.map(w=>(<WeekCard key={w.id} week={w} />))}
      {weeks.length===0 && <div className='card empty'>No weeks yet.</div>}
    </div>
  </div>);
}
